// extracted by mini-css-extract-plugin
module.exports = {"section":"homepage-chart-box_section_3S9Fa"};